// src/utils/validation.ts
export const validateRequired = (value: any) => {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "") ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return "Bu alan zorunludur";
  }

  return null;
};

/*
 * `validateSchedule` 2.35'te KALDIRILDI: departmanın haftalık mesai planını
 * doğruluyordu, o form artık yok. Vardiya tanımının deseni kendi formunda
 * (`ShiftDefinitionForm`) ve backend'de (`normalizeDays`) doğrulanıyor.
 */


export const validateMinLength = (min: number) => (value: string) => {
  return value.length >= min ? null : `En az ${min} karakter olmalı`;
};

export const validateMaxLength = (max: number) => (value: string) => {
  return value.length <= max ? null : `En fazla ${max} karakter olmalı`;
};

export const validatePhoneNumberStartsWithZero = (value: string) => {
  return value.startsWith("0")
    ? null
    : "Telefon numaranız 0 ile başlayarak yazılmalı";
};

export const validatePhoneNumberIsNumeric = (value: string) => {
  const regex = /^\d+$/;
  return regex.test(value)
    ? null
    : "Telefon numarası yalnızca rakamlardan oluşmalı";
};

export const validateNoSpaces = (value: string) => {
  const trimmedValue = value.trim();
  return value !== trimmedValue ? "Boşluk bırakmadan yazılmalı" : null;
};

export const combineValidators =
  (...validators: ((value: string) => string | null)[]) =>
  (value: string) => {
    for (const validator of validators) {
      const error = validator(value);
      if (error) return error;
    }
    return null;
  };
